/*eslint-disable angular/angularelement */

import formGroupTemplate from './form-group.tpl.html';
import './form-group.less';
import { formGroupMessagesComponentModule } from '../form-group-messages/form-group-messages';

const $ = angular.element;

function _addAttrIfMissing($node, attr, val) {
  if (!$node.attr(attr)) {
    $node.attr(attr, val);
  }
}

export const formGroupComponentModule = angular
  .module('Q.components.forms.form-group', [formGroupMessagesComponentModule])

  // This directive enables us to recompile the content of the form-group, so we can
  // automatically add content like form-group-messages, labels, and name/id/form references.
  // This saves a lot of extra redundant text in general.
  .directive('formGroup', function () {
    return {
      restrict: 'E',
      priority: 50.1,
      require: '^form',
      compile(tElement, iAttrs) {
        // determine node name
        const $input = tElement.querySelector('[ng-model]');
        const name =
          $input.attr('name') || $input.attr('id') || $input.attr('ng-model');
        const id = $input.attr('id') || name;

        _addAttrIfMissing($input, 'name', name);
        _addAttrIfMissing($input, 'id', id);

        // Add generic label if missing, and add attributes if existing
        let $label = tElement.find('label').eq(0);
        if ($label.length === 0 && iAttrs.label) {
          $label = $('<label>');
          $label.text(iAttrs.label);
          tElement.prepend($label);
        }
        _addAttrIfMissing($label, 'for', id);
        $label.addClass('control-label');

        // Add generic messages block if missing
        let $errors = tElement.querySelector('form-group-messages');
        if (!$errors.length) {
          $errors = $('<form-group-messages></form-group-messages>');
          tElement.append($errors);
        }
      },
    };
  })

  // This directive runs at a lower priority, and enables us to do two things:
  // 1. Hook into the focus/blur events of any child inputs.
  // 2. Capture data used by our form-group-messages controller so we can generate nice generic error messages.
  .directive('formGroup', function () {
    return {
      restrict: 'E',
      require: 'formGroup',
      priority: 50,
      transclude: true,
      template: formGroupTemplate,
      controller: function FormGroupCtrl($element) {
        let ctrl = this;
        ctrl.setFocus = (hasFocus) =>
          $element.children().toggleClass('has-focus', hasFocus);
      },
      link(scope, elem, attrs, formGroupCtrl) {
        elem.children().addClass(attrs.formGroupClass);
        if (attrs.hasSuccess) {
          scope.$watch(attrs.hasSuccess, (val) => {
            elem.children().toggleClass('has-success', !!val);
          });
        }
        if (attrs.hasWarning) {
          scope.$watch(attrs.hasWarning, (val) => {
            elem.children().toggleClass('has-warning', !!val);
          });
        }
        scope.$applyAsync(() => {
          let $inputs = elem.querySelectorAll('[ng-model]');
          formGroupCtrl.$inputs = $inputs;
          formGroupCtrl.attrs = attrs;
          $inputs.on('focus', () => formGroupCtrl.setFocus(true));
          $inputs.on('blur', () => formGroupCtrl.setFocus(false));

          if (formGroupCtrl.configureMessages) {
            formGroupCtrl.configureMessages($inputs);
          }
        });
      },
    };
  });
